
export const featureFlags = {
  colorSearchEnabled: false,
  fitmentSearchEnabled: true,
  searchPageEnabled: true,
  contextDialogEnabled: true,
  infiniteScrollEnabled: true,
  searchEnabled: true
};
export const colorSearchEnabled = featureFlags.colorSearchEnabled;
export const fitmentSearchEnabled = featureFlags.fitmentSearchEnabled;
export const searchPageEnabled = featureFlags.searchPageEnabled;
export const contextDialogEnabled = featureFlags.contextDialogEnabled;
export const infiniteScrollEnabled = featureFlags.infiniteScrollEnabled;
export const searchEnabled = featureFlags.searchEnabled;
